// http://stackoverflow.com/a/46181/696130
export const EMAIL_REGEX =
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export const DOMAIN_REGEX =
  /^(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

// extract all emails from a block of text
export const EXTRACT_EMAILS_REGEX =
  /(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})/gi;

export const LOOM_SHARE_PAGE_REGEX_STR =
  '(?:https?://)?((?:stage.loom.com|loom.com|www.loom.com|loomlocal.com:4444)/share/[a-f0-9]+)';

export const URL_REGEX =
  /^((https?|ftp):\/\/)(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

export const MAX_COMMENT_LENGTH = 5000;
export const MAX_COMMENT_SERVER_LENGTH = 7000; // maximum allowable HTML limit in table
export const MAX_IPV6_LENGTH = 45;
export const MAX_VIDEO_NAME_LENGTH = 100;
export const MIN_COMMENT_LENGTH = 1;
export const FOLDER_BANNED_CHARS_ARR = [
  '<',
  '>',
  '\\',
  '/',
  ':',
  '?',
  '*',
  '"',
  '|',
];

export const BANNED_CHARS_REGEX = new RegExp(
  `\\${FOLDER_BANNED_CHARS_ARR.join('|\\')}`,
  'i'
);

export const BANNED_CHARS_ERROR_MESSAGE = `The following characters are not allowed: ${FOLDER_BANNED_CHARS_ARR.join(
  ' '
)}`;

export const FIRST_NAME_MAX_LENGTH = 60;
export const FIRST_NAME_MAX_PARTS = 2;
export const MIN_PASSWORD_LENGTH = 8;

export const HEX_REGEX = /^[a-fA-F0-9]+$/;
export const HEX_32_REGEX = '[a-fA-F0-9]{32}';
export const ATTACHMENT_S3_ID_REGEX = HEX_32_REGEX;
export const COUPON_ID_REGEX = HEX_32_REGEX;
export const EMAIL_VERIFICATION_TOKEN_REGEX = HEX_32_REGEX;
export const FOLDER_ID_REGEX = HEX_32_REGEX;
export const INCOMPLETE_USER_TOKEN_REGEX = HEX_32_REGEX;
export const RESET_PASSWORD_TOKEN_REGEX = HEX_32_REGEX;
export const ORGANIZATION_INVITATION_REGEX = HEX_32_REGEX;
export const VIDEO_ID_REGEX = HEX_32_REGEX;
export const SHARE_ID_REGEX = HEX_32_REGEX;
export const ANONYMOUS_ID_REGEX = HEX_32_REGEX;
export const VIDEO_TIMESTAMP_REGEX = /^(\d+):([0-5]\d)?$/i;
export const POSITIVE_FLOAT_REGEX = /^\d+(\.\d+)?$/;
export const POSITIVE_INTEGER_REGEX = /^\d+$/;
export const SCREENSHOT_ID_REGEX = HEX_32_REGEX;
export const SCREENSHOT_URL_ID_REGEX = '[a-zA-Z0-9]{18,32}';

// Validates for 'YYYY-MM-DD'
export const DATE_RANGE_REGEX =
  /^\d{4}-((0[0-9])|(1[0-9]))(-((0[1-9])|([1-2][0-9])|(3[0-1])))$/;

export const PART_NUMBER_REGEX =
  /^sessions\/raw\/[a-fA-F0-9]+-(\d+)\.(?:ts|m4s)/;

export const EMBED_VIDEO_ROUTE_PATHNAME_REGEX = new RegExp(
  `^\/embed\/(${VIDEO_ID_REGEX})$`,
  'i'
);

export const SHARE_VIDEO_ROUTE_PATHNAME_REGEX = new RegExp(
  `^\/share\/(${VIDEO_ID_REGEX})$`,
  'i'
);

// http://stackoverflow.com/a/11067610/696130
export const HHMMSS_REGEX = /(?:([0-5]?[0-9]):)?([0-5]?[0-9]):([0-5][0-9])/g;
export const HHMMSS_REGEX_SINGLE =
  /(?:([0-5]?[0-9]):)?([0-5]?[0-9]):([0-5][0-9])/;

export const USER_ROLE_REGEX = /^(thinker|admin|client)$/;

export const HEX_COLOR_REGEX = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i;

export const ALL_DASHES_REGEX = /\-/g;

export const BLACKLISTED_NAME_CHARACTERS = /[@.]/;

export const PASSWORD_WITHOUT_SPACES = /^\S+$/;

export const URL_FOLDER_ID_REGEX = new RegExp(`-${FOLDER_ID_REGEX}$`);

export const blacklistedNameCharacters = str => {
  return BLACKLISTED_NAME_CHARACTERS.test(str);
};

export const email = email => {
  return EMAIL_REGEX.test(email);
};

export const domain = domain => {
  return DOMAIN_REGEX.test(domain);
};

export const url = url => {
  return URL_REGEX.test(url);
};

// taken from: https://github.com/sindresorhus/ip-regex
export const ipRegex = () => {
  const v4 =
    '(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])(?:\\.(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])){3}';

  const v6seg = '[0-9a-fA-F]{1,4}';
  const v6 = `
  (
  (?:${v6seg}:){7}(?:${v6seg}|:)|                                // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
  (?:${v6seg}:){6}(?:${v4}|:${v6seg}|:)|                         // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
  (?:${v6seg}:){5}(?::${v4}|(:${v6seg}){1,2}|:)|                 // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
  (?:${v6seg}:){4}(?:(:${v6seg}){0,1}:${v4}|(:${v6seg}){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
  (?:${v6seg}:){3}(?:(:${v6seg}){0,2}:${v4}|(:${v6seg}){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
  (?:${v6seg}:){2}(?:(:${v6seg}){0,3}:${v4}|(:${v6seg}){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
  (?:${v6seg}:){1}(?:(:${v6seg}){0,4}:${v4}|(:${v6seg}){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
  (?::((?::${v6seg}){0,5}:${v4}|(?::${v6seg}){1,7}|:))           // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
  )(%[0-9a-zA-Z]{1,})?                                           // %eth0            %1
  `
    .replace(/\s*\/\/.*$/gm, '')
    .replace(/\n/g, '')
    .trim();

  const ip = opts =>
    opts && opts.exact
      ? new RegExp(`(?:^${v4}$)|(?:^${v6}$)`)
      : new RegExp(`(?:${v4})|(?:${v6})`, 'g');

  ip.v4 = opts =>
    opts && opts.exact ? new RegExp(`^${v4}$`) : new RegExp(v4, 'g');
  ip.v6 = opts =>
    opts && opts.exact ? new RegExp(`^${v6}$`) : new RegExp(v6, 'g');

  return ip;
};

export const hex = str => {
  return HEX_REGEX.test(str);
};

export const isHexColor = str => {
  return HEX_COLOR_REGEX.test(str);
};

// http://stackoverflow.com/a/4059166/696130
export const isString = obj => {
  return typeof obj === 'string';
};

export const stringNotEmpty = str => {
  return isString(str) && str.trim().length > 0;
};

const PASSWORD_RULES = {
  MIN_LENGTH: pw => pw.length < 8,
  MAX_LENGTH: pw => pw.length > 64,
  UPPER_CASE: pw => !/[A-Z]+/.test(pw),
  LOWER_CASE: pw => !/[a-z]+/.test(pw),
  NUMBER: pw => !/\d+/.test(pw),
  SYMBOL: pw => !/[^a-zA-Z0-9]+/.test(pw),
};

const PASSWORD_EXPLANATION = {
  MIN_LENGTH: 'at least 8 characters',
  MAX_LENGTH: 'at most 64 characters',
  UPPER_CASE: 'at least one uppercase character',
  LOWER_CASE: 'at least one lowercase character',
  NUMBER: 'at least one digit (0-9)',
  SYMBOL: 'at least one symbol (!, $, @, *, etc)',
};

export const validatePassword = password => {
  if (!isString(password)) {
    return ['INVALID_STRING'];
  }

  return Object.keys(PASSWORD_RULES).filter(rule => {
    return PASSWORD_RULES[rule](password);
  });
};

// This function is a backwards-compatible password validation function
// that will be used in the backend until all clients can handle the new validations.
export const validatePasswordMinLength = password => {
  if (!isString(password)) {
    return false;
  }

  return !PASSWORD_RULES['MIN_LENGTH'](password);
};

export const explainPasswordViolations = passwordViolations => {
  if (passwordViolations.length === 0) {
    return null;
  }

  return (
    'Password needs: ' +
    passwordViolations
      .map(rule => {
        return PASSWORD_EXPLANATION[rule];
      })
      .join(', ')
  );
};

export const videoTimestamp = str => {
  return VIDEO_TIMESTAMP_REGEX.test(str);
};

export const getEmailDomain = email => {
  return `@${email.split('@')[1]}`;
};

export function invalidUserFirstName(firstName) {
  if (firstName.length > FIRST_NAME_MAX_LENGTH) {
    return 'First Name cannot be greater than 50 characters';
  }

  if (firstName.split(' ').length > FIRST_NAME_MAX_PARTS) {
    return 'First Name cannot have more than 2 parts';
  }

  if (blacklistedNameCharacters(firstName)) {
    return 'First Name can not contain special characters except ! ( ) and -';
  }

  return null;
}
